import { VolumeOff, VolumeUp } from '@mui/icons-material';

import { tOrder } from '@frontend/locales';

import { usePersistentUiSettings } from '../utils';
import { IconActionButton } from './icon-action-button.component';

export const SoundAction = () => {
  const { ordersPage, updateOrdersPage } = usePersistentUiSettings();

  const audioIcon = () => {
    if (ordersPage.audio.enabled) {
      return <VolumeUp />;
    } else {
      return <VolumeOff />;
    }
  };

  return (
    <>
      <IconActionButton
        icon={audioIcon()}
        title={
          ordersPage.audio.enabled
            ? tOrder.actions.audioMute()
            : tOrder.actions.audioUnmute()
        }
        ariaDescription={
          ordersPage.audio.enabled
            ? tOrder.actions.audioMute()
            : tOrder.actions.audioUnmute()
        }
        onClick={() => {
          if (ordersPage.audio.enabled) {
            updateOrdersPage({
              audio: {
                ...ordersPage.audio,
                enabled: false,
              },
            });
          } else {
            updateOrdersPage({
              audio: {
                ...ordersPage.audio,
                enabled: true,
              },
            });
          }
        }}
      />
    </>
  );
};
